const contentful = require("contentful");

export const client = contentful.createClient({
    // This is the space ID. A space is like a project folder in Contentful terms
    space: "ed6cvln0cfgb",
    // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
    accessToken: "K8PUeE7DymxEMJJT2-Xpa0LiqIYtqqxMcSrEOrgiGv4"
});



